/**
 * Full-page checkout when CDN CSP blocks embedding (missing payment origin in frame-src).
 * Test uses this until CloudFront frame-src includes the protectedpayments payment host.
 */
export const checkoutUsesTopLevelNavigation =
  process.env.REACT_APP_CHECKOUT_USE_TOP_LEVEL === "true";

/** Gift payment: 3s loader then static screenshot (e.g. CSP blocks iframe on test). */
export const giftPaymentUsesStaticPreview =
  process.env.REACT_APP_GIFT_PAYMENT_STATIC_PREVIEW === "true";
